

















import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import Detail from './components/DetailModal.vue';
import { Popup } from 'vant';
import * as config from './config';
import DetailModal from './components/DetailModal.vue';
import SuccessModal from './components/SuccessModal.vue';

Vue.use(Popup);
@Component({
  components: {
    VoteList,
    Detail,
    DetailModal,
    SuccessModal,
  },
})
export default class First extends Vue {
  option = config.OPTHINES;
  guide = true;
  closeGuide() {
    this.guide = false;
  }
}
